import React from 'react';

/**
 * PageHeader — shared page title primitive introduced by the R2 shell revamp.
 *
 * @param {Object} props
 * @param {React.ReactNode} props.title - Page title, rendered as an h1 in Manrope 800.
 * @param {React.ReactNode} [props.subtitle] - Optional descriptive line under the title.
 * @param {React.ReactNode} [props.right] - Slot for segmented controls, filters, buttons.
 * @param {string} [props.testId] - Optional data-testid.
 */
export default function PageHeader({ title, subtitle, right, testId }) {
    return (
        <header
            className="flex items-start justify-between gap-3 mb-4"
            data-testid={testId}
        >
            <div className="min-w-0">
                <h1
                    className="truncate"
                    style={{
                        fontFamily: 'Manrope, system-ui, sans-serif',
                        fontSize: 19,
                        fontWeight: 800,
                        color: 'var(--ink-1)',
                        letterSpacing: '-0.01em',
                        margin: 0,
                    }}
                >
                    {title}
                </h1>
                {subtitle && (
                    <p
                        className="mt-1"
                        style={{
                            fontSize: 12.5,
                            color: 'var(--ink-label)',
                            margin: 0,
                        }}
                    >
                        {subtitle}
                    </p>
                )}
            </div>
            {right && <div className="flex items-center gap-2">{right}</div>}
        </header>
    );
}
